import React from 'react';

import { FormattedMessage } from 'react-intl';

// core components
import GridContainer from "components/react-template/Grid/GridContainer.jsx";
import GridItem from "components/react-template/Grid/GridItem.jsx";

class NoLoading extends React.Component {

    handleRetry = event => {
        event.preventDefault();
        this.props.onRetry();
    }

    handleReLoad = event => {
        event.preventDefault();
        window.location.reload(true);
    }

    render() {

        return (
            <div>
                <GridContainer justify={"space-between"} alignItems={"center"} direction={"column"} className={"error-container"}>
                    <GridItem></GridItem>
                    <GridItem className={"error-body"}>
                        <div className={'error-title'}><FormattedMessage id="page.loading.failure.title" /></div>
                        <div className={'error-sub'}>
                            <FormattedMessage id="page.loading.failure.desc.01" /> 
                            <br/>
                            <FormattedMessage id="page.loading.failure.desc.02" />
                        </div>
                        <div className={'error-button'}>
                            <button
                                onClick={this.handleRetry}
                            >
                                <FormattedMessage id="common.retry" />
                            </button>
                            <button 
                                className={'last'}
                                onClick={this.handleReLoad}
                            >
                                <FormattedMessage id="common.refresh" />
                            </button>
                        </div>
                    </GridItem>
                    <GridItem className={"error-footer"}>
                        <FormattedMessage id="common.copyright" />
                    </GridItem>
                </GridContainer>
            </div>
        );
    }

};

export default NoLoading;